import {
    EXTRAS_ANCILLARY_PACK_PAAG,
    EXTRAS_ANCILLARY_PACK_PAAB,
    EXTRAS_ANCILLARY_PACK_PAAA,
    EXTRAS_ANCILLARY_PACK_PAAI,
    EXTRAS_ANCILLARY_PACK_PAAQ,
    EXTRAS_ANCILLARY_PREF_BOARD,
    EXTRAS_ANCILLARY_FAST_TRACK,
    EXTRAS_ANCILLARY_LOUNGE,
    EXTRAS_ANCILLARY_SEAT,
} from '@ibe.config';
import { INDRAAddOnAncillary } from '@ibe.models/ancillary.indra.model.lib';
import { packFeature, service } from '@ibe.components/booking/flights/brand/brand.indra';

export class Bundles {

    private _flight: any;
    private _pack_selected_services: any = [];

    bundle_features: any;
    extra_features: any = [];
    extras_availables: any = [];
    features_added: INDRAAddOnAncillary[];

    brand: string;

    constructor(
        flight: any,
        bundle_features: any,
        extra_features: any,
        features_added: INDRAAddOnAncillary[],
    ) {
        this._flight = flight;
        this.bundle_features = bundle_features;
        this.extra_features = extra_features;
        this.features_added = features_added;

        this.INDRA_init();
    }

    get pack_selected_services(): any {
        this.INDRA_getAllPackSelectedServices();

        return this._pack_selected_services;
    }

    INDRA_init() {
        if (this.bundle_features.length > 0) {
            //Only show bundles having services listed among Extras
            this.INDRA_getAllPackSelectedServices();

            this.INDRA_hideExtraDiscount();

            this.INDRA_updateExtras();            
        }
    }

    /**
     * If an extra is part of a pack service, any discount should be removed.
     */
    INDRA_hideExtraDiscount() {

        let features = [...this.extra_features];

        this.extra_features.forEach(e => {
            let ext = { ...e, previous_price: 0 };

            if (this.INDRA_isPackService(e) && e.previous_price) {
                const index = features.findIndex(s => s.id == e.id);
                features.splice(index, 1, ext);
            }
        });

        this.extra_features = [...features];
    }

    /**
     * Returns all pack selected services
     */
    INDRA_getAllPackSelectedServices() {
        this._pack_selected_services = [];

        const packs_selected = this.bundle_features.filter((b) => {
            const pack = new PackFeature(b);

            return this.featureCount(pack) > 0
        });

        packs_selected.forEach(p => {
            let services = this.getPackFeatures(p);
            this._pack_selected_services.push(...services);
        });
    }

    /**
     * Update extras after a pack selection or removal(only for single choice ancillaries ex: PB, FT, L, AC and Seats)
     */

    INDRA_updateExtras() {

        this.extras_availables = [];

        this.extra_features.map(feature => {
            if (
                feature.type == EXTRAS_ANCILLARY_PREF_BOARD
                || feature.type == EXTRAS_ANCILLARY_FAST_TRACK
                || feature.type == EXTRAS_ANCILLARY_LOUNGE
                || feature.type == EXTRAS_ANCILLARY_SEAT
            ) {
                if (!this._pack_selected_services.some(e => e.id == feature.id)) {
                    this.extras_availables.push(feature);
                }
            } else {
                this.extras_availables.push(feature);
            }
        });
    }

    /**
     * Look for current pack services among selected packs services
     */
    INDRA_hasServiceSelected(pack: any) {
        let current_services = this.getPackFeatures(pack);
        let serviceExist = false;

        for (let i = 0; i < this._pack_selected_services.length && !serviceExist; i++) {
            serviceExist = current_services.some(c => c.id == this._pack_selected_services[i].id);
        }

        return serviceExist;
    }

    /**
     * Returns true if extra is part of any pack service
     */
    INDRA_isPackService(extra: any): boolean {
        let belong = false;

        for (let i = 0; i < this.bundle_features.length && !belong; i++) {
            belong = this.getPackFeatures(this.bundle_features[i]).some(s => s.id == extra.id);
        }
        return belong;
    }

    featureCount(feature) {
        return new FeaturesMap(this._flight, this.features_added).getCount(feature);
    }

    INDRA_getPacksbyExtra(feature: any): any {
        const selected_services = this.pack_selected_services;

        let packs: any = [];
        packs = this.bundle_features.filter(pack => {
            const catalogs = pack.ancillaryList[0].catalog;
            const flightCatalog = catalogs.filter(catalog => catalog.flightId == this._flight.details.idFlight);

            if (flightCatalog && flightCatalog.length) {
                let packAvailable = false;
                flightCatalog.forEach(catalog => {
                    const packAncillaryList = catalog.passengers[0].codeList[0].ancillaryPackInfo.ancillaryDescription;
                    
                    let packHasFeature = false;
                    let packOtherFeaturesAlreadySelected = false;
                    
                    packAncillaryList.forEach((p) => {
                        if (p.type == feature.type) {
                            // Check if the selected ancillary exist on this pack
                            packHasFeature = true;
                        } else {
                            // Check if other ancillaries on this pack are already added to cart by individual ancillary of by pack
                            if (!packOtherFeaturesAlreadySelected) {
                                packOtherFeaturesAlreadySelected = this.features_added.some(f => f.code == p.code) || selected_services.some(s => s.type == feature.type);
                            }
                        }
                    });
                    if (packHasFeature && !packOtherFeaturesAlreadySelected) {
                        packAvailable = true;
                    }
                });
                
                return packAvailable;
            } else {
                return false;
            }
        });

        return packs;
    }

    INDRA_hasAnyBagPackSelected(){
		// const hasBag3 = this.featureCount(PAAA) > 0;
		// const hasBag2 = this.featureCount(PAAB) > 0;

		// return  hasBag3 || hasBag2;
        return false;
	}

	INDRA_getBagsbyPack(){
		// const count_bags2 = this.featureCount(PAAB);
		// const count_bags3 = this.featureCount(PAAA);

		// return count_bags2 + count_bags3;
        return 0;
	}

    INDRA_hasBaginFare(){
        // return this._flight.amadeusBrand.toLowerCase() != 'discount';
    }

    getPackFeatures(pack: any) {
        const catalogs = pack.ancillaryList[0].catalog;
        const flightCatalog = catalogs.find(catalog => catalog.flightId == this._flight.details.idFlight);
        const packAncillaryList =  flightCatalog && flightCatalog.length ? flightCatalog.passengers[0].codeList[0].ancillaryPackInfo.ancillaryDescription : [];

        const packAncillaryTypes = [];

        packAncillaryList.forEach((p) => {
            packAncillaryTypes.push(p.type);
        })

        let services = this.extra_features.filter(feature => packAncillaryTypes.includes(feature.type));
    
        return services;
    }
}

class PackFeature implements packFeature{
	code: string;
	name: string;
	id: string;
	label: string;
	description: string;
	type: 'pack';
	price: number;
	action: { label: string, route: string };
	order: number;
	services: service[];

    constructor(pack: any) {
        const ancillaryInfo = pack.ancillaryList[0].catalog[0].passengers[0].codeList[0];
        this.code = pack.ancillaryList[0].type;
        this.name = pack.name;
        this.label = ancillaryInfo.freeText;
        this.description = ancillaryInfo.freeText;
        this.id = pack.bundleId;
        this.price = ancillaryInfo.price
        this.services = ancillaryInfo.ancillaryPackInfo.ancillaryDescription;
    }
}

class FeaturesMap {
	flight: any;
    features_added: INDRAAddOnAncillary[];
    current_feature: INDRAAddOnAncillary

	properties_mapping = {};

	constructor(flight: any, features_added: INDRAAddOnAncillary[]) {
		this.flight = flight;
        this.features_added = features_added;
	}

	getCost(feature: INDRAAddOnAncillary) {
        if (!this.properties_mapping[feature.code]) {
            this.properties_mapping[feature.code] = {
                changed: this.propertyChanged,
                count: this.propertyCount,
                cost: this.propertyCost,
            }
        }
		const property = this.properties_mapping[feature.code];

        this.current_feature = feature;

		return this.flight && property ? property.cost.apply(this) : 0;
	}

	hasChanged(feature: INDRAAddOnAncillary) {
        if (!this.properties_mapping[feature.code]) {
            this.properties_mapping[feature.code] = {
                changed: this.propertyChanged,
                count: this.propertyCount,
                cost: this.propertyCost,
            }
        }
		const property = this.properties_mapping[feature.code];

        this.current_feature = feature;

		return this.flight && property ? property.changed.apply(this) : false;
	}

	getCount(feature: INDRAAddOnAncillary) {
        if (!this.properties_mapping[feature.code]) {
            this.properties_mapping[feature.code] = {
                changed: this.propertyChanged,
                count: this.propertyCount,
                cost: this.propertyCost,
            }
        }
		const property = this.properties_mapping[feature.code];

        this.current_feature = feature;

		return this.flight && property ? property.count.apply(this) : 0;
	}

    private propertyChanged() {
        this.propertyCount() > 0;
    }

    private propertyCount() {
        return this.features_added.reduce(((sum, item) => sum + (this.current_feature && item.code === this.current_feature.code ? 1 : 0)), 0);
    }

    private propertyCost() {
        return this.features_added.reduce(((sum, item) => sum + (this.current_feature && item.code === this.current_feature.code ? parseFloat(item.price.toString()) : 0)), 0);
    }
}
